import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryQuickNav from '@/pages/home/components/CategoryQuickNav';
import LatestMovies from '@/pages/home/components/LatestMovies';
import NewsHighlights from '@/pages/home/components/NewsHighlights';
import SiteIntro from '@/pages/home/components/SiteIntro';
import { movies } from '@/mocks/movies';
import { news } from '@/mocks/news';
import type { Movie, NewsArticle } from '@/types/media';

export default function Home() {
  const movieList = movies as Movie[];
  const newsList = news as NewsArticle[];

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <h1 className="sr-only">翔田千里影视大全 - 最新电影电视剧资讯平台</h1>
        <HeroCarousel />
        <CategoryQuickNav />
        <LatestMovies movies={movieList} />
        <NewsHighlights news={newsList} />
        <SiteIntro />
      </main>
      <SiteFooter />
    </div>
  );
}